import RestAPI from '../../../components/Common/restApi';

export default class AppsApi {
  static updateApp(asset_id, data) {
    return RestAPI.updateWithFormData(`/alpha/organization/apps/${asset_id}`, data);
  }

  static getStatus(asset_id) {
    return RestAPI.get(`/alpha/organization/apps/${asset_id}/status`);
  }

  static toggleZapier(enabled) {
    return RestAPI.postWithFormData(`/pro/apps/toggle_zapier/${enabled}`);
  }

  static enableVirtualEstimate() {
    return RestAPI.postWithFormData(`/pro/apps/enable_virtual_estimate`);
  }

  static getActiveApps() {
    return RestAPI.get('/pro/apps/active_apps');
  }
}
